import { useIsJobInterviewsEnabled } from "./useIsJobInterviewsEnabled";

// A hook to wrap some additional display conditions around the "Interview Availability" menu item
// This hook is used just to determine the visibility of the menu item, not the actual functionality of the page
// or routing
export function useIsInterviewAvailabilityMenuVisible(): boolean {
  return useIsJobInterviewsEnabled();
}
